<template>
  <div class="dashboard-banners" v-cloak>
    <div v-for="b in banners" :key="b.id" class="text-center alert" :class="alertClass">
      <span v-if="b.link_url">
        {{ prefix(b.message) }}
          <strong><a :href="b.link_url" target="_blank" rel="noopener">{{ b.link_label || 'here' }}</a></strong>{{ suffix(b.message) }}
      </span>

      <span v-else>
        {{ b.message }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dashboard-banners',

  props: {
    alertClass: {
      type: String,
      default: 'alert-info',
    },
    linkToken: {
      type: String,
      default: ':link',
    },
  },

  data() {
    return {
      banners: [],
    };
  },

  methods: {
    fetchBanners() {
      this.$http.get('/overview/banners').then(
        (response) => {
          this.banners = Array.isArray(response.data) ? response.data : [];
        },
        () => {
          this.banners = [];
        }
      );
    },

    prefix(message) {
      const msg = (message || '').toString();
      const token = this.linkToken;
      const idx = msg.indexOf(token);

      if (idx === -1) return msg;
      return msg.slice(0, idx);
    },

    suffix(message) {
      const msg = (message || '').toString();
      const token = this.linkToken;
      const idx = msg.indexOf(token);

      if (idx === -1) return '';
      return msg.slice(idx + token.length);
    },
  },

  mounted() {
    this.fetchBanners();
  },
};
</script>

<style scoped lang="scss">
.dashboard-banners {
  .alert {
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// dashboard-banners.vue?37ed9dff